import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M9 15h-2","key":"svg-1"}],["path",{"d":"M13 12h-6","key":"svg-2"}],["path",{"d":"M11 9h-4","key":"svg-3"}]]

const IconAlignBoxLeftMiddle = createReactComponent('outline', 'align-box-left-middle', 'AlignBoxLeftMiddle', __iconNode);

export default IconAlignBoxLeftMiddle;